export default __webpack_public_path__ + "static/revenue-521fe9e5b3b8c5902261dab627788478.png";